var map = {
	"./arrow-left.svg": "JREx",
	"./arrow-right.svg": "V65C",
	"./check.svg": "5aLq",
	"./chevron-right.svg": "sgU1",
	"./corner-down-left.svg": "ZqRJ",
	"./daemon-skull.svg": "6mMV",
	"./heart.svg": "QVSs",
	"./info.svg": "25i3",
	"./refresh-cw.svg": "Nk5a",
	"./rotate-cw.svg": "+ily",
	"./x.svg": "EzMw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UKcq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.svg$
// module id = UKcq
// module chunks = 1